import styled from 'styled-components';

import { StatusBanner } from '@xing-com/banner';
import { Button } from '@xing-com/button';
import { spaceL } from '@xing-com/tokens';
import { BodyCopy } from '@xing-com/typography';

export const UploadButton = styled(Button)`
  margin-top: ${spaceL};
  width: 100%;
  &:hover::after {
    transform: none;
  }
`;

export const FileFormatTip = styled(BodyCopy)`
  margin: ${spaceL} 0;
`;

export const AriaMessage = styled.div`
  clip: rect(0 0 0 0);
  clip-path: inset(50%);
  height: 1px;
  overflow: hidden;
  position: absolute;
  white-space: nowrap;
  width: 1px;
`;

export const RequiredErrorBanner = styled(StatusBanner)`
  margin-top: ${spaceL};
`;
